import axios from "axios";
import { API } from "../config";

export const getCompanyHistory = async () => {
    const data = await axios.get(API.COMPANY_HISTORY);

    return data.data;
};

export const insertCompanyHistory = async (history) => {
    let params = new URLSearchParams();

    params.append("year", history.year);
    params.append("content", history.content);

    await axios
        .post(API.COMPANY_HISTORY, params)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const deleteCompanyHistory = async (id) => {
    await axios
        .delete(API.COMPANY_HISTORY + "/" + id)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const updateCompanyHistory = async (id, year, content) => {
    let params = new URLSearchParams();

    params.append("year", year);
    params.append("content", content);

    await axios
        .put(API.COMPANY_HISTORY + "/" + id, params)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const getStandardYearList = async () => {
    const data = await axios.get(API.STANDARD_YEAR);

    return data.data;
};

export const insertStandardYear = async (year) => {
    let params = new URLSearchParams();

    params.append("year", year);

    await axios
        .post(API.STANDARD_YEAR, params)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const deleteStandardYear = async (year) => {
    await axios
        .delete(API.STANDARD_YEAR + "/" + year)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};
